document.addEventListener('DOMContentLoaded', function () {
	document
		.querySelectorAll('.navigation-featured-link-card')
		.forEach((card) => {
			const button = card.querySelector('.wp-block-button__link');
			const fullCardLink = card.querySelector('.full-card-link');

			if (button && fullCardLink) {
				const href = button.getAttribute('href');
				if (href) {
					fullCardLink.setAttribute('href', href);
				}
			}
		});
});
